// Will include the page title for every route.

const pageTitle = {
  // route : page tile

  /* ***********************  OVERVIEW  ********************** */

  '/overview': 'Account Overview',

  /* ***********************  SUBJECT-MANAGEMENT ********************** */

  '/subject-management/subject-details': 'Subject Management - Subject Details',
};

export { pageTitle };
